import { $http } from '@/plugins/common/http';

export const getBrandNameRegisterPrice = () => {
    return $http.get('/sms/brand-name/register/price');
};

export const getBrandNameList = (query) => {
    return $http.get('/user/sms/brand-name', {
        params: {
            ...query,
        },
    });
};

export const downloadBrandNameTemplate = (options) => {
    return $http.get('/user/sms/brand-name/register-form', options);
};

export const downloadUserReceiveTemplate = (options) => {
    return $http.get('/user/sms/user-receive-template', options);
};

export const getPresignedPostPolicy = (query) => {
    return $http.get('/user/sms/brand-name/register/upload-file-url', {
        params: {
            ...query,
        },
    });
};

export const uploadFile = (url, data) => {
    return $http.post(url, data, {
        transformRequest: (data, headers) => {
            delete headers.common['Authorization'];
            delete headers['Authorization'];
            headers.common['Content-Type'] = 'multipart/form-data';
            headers['Content-Type'] = 'multipart/form-data';
            return data;
        },
    });
};

export const getSmsRules = () => {
    return $http.get('/sms/rules');
};

export const getSmsTemplateList = (query) => {
    return $http.get('/user/sms/templates', {
        params: {
            ...query,
        },
    });
};

export const deleteTemplate = (id) => {
    return $http.delete('user/sms/templates/' + id);
};

export const crateSmsTemplate = (data) => {
    return $http.post('/user/sms/templates', data);
};

export const updateSmsTemplate = (id, data) => {
    return $http.patch('/user/sms/templates/' + id, data);
};

export const getAllBrandNames = () => {
    return $http.get('/user/sms/brand-name/all');
};

export const getSmsTransactions = (query) => {
    return $http.get('user/sms/transactions', {
        params: {
            ...query,
        },
    });
};
export const getSmsTransactionById = (id, appendUserReceiver = false) => {
    return $http.get('user/sms/transactions/' + id, {
        params: {
            ...(appendUserReceiver && { appendUserReceiver }),
        },
    });
};

export const getCustomersByTransactionId = (id, query) => {
    return $http.get('user/sms/transactions/' + id + '/receivers', {
        params: {
            ...query,
        },
    });
};

export const exportCustomerReceiversReport = (id, options) => {
    return $http.get('user/sms/transactions/' + id + '/export', options);
};

export const getSmsTransactionBySchedule = (begin, end) => {
    return $http.get('user/sms/schedules', {
        params: {
            begin,
            end,
        },
    });
};

export const getSmsTransactionDetailBySchedule = (transactionId, date) => {
    return $http.get('user/sms/schedules/transaction/' + transactionId, {
        params: {
            date,
        },
    });
};

export const calculateSmsPrice = (data) => {
    return $http.post('user/sms/calculate-price', data);
};

export const sendSms = (data, options = { timezone: undefined }) => {
    const { timezone } = options;
    return $http.post('/user/sms', data, {
        headers: {
            ...$http.defaults.headers.common,
            ...(timezone && { ['x-time-zone']: timezone }),
        },
    });
};

export const getScheduleDetailReceivers = (transactionId, query) => {
    return $http.get(
        '/user/sms/schedules/transaction/' + transactionId + '/receivers',
        {
            params: {
                ...query,
            },
        }
    );
};

export const sendSmsOTP = (type) => {
    return $http.get(`/user/sms/otp/send/${type}`);
};

export const verifySmsOTP = (data) => {
    return $http.post('/user/sms/otp/verify/', data);
};
export const getSMSResults = (transactionId, query) => {
    return $http.get(
        '/user/sms/transactions/' + transactionId + '/transaction-details',
        {
            params: {
                ...query,
            },
        }
    );
};

export const cancelTransaction = (transactionId) => {
    return $http.delete(`/user/sms/transactions/${transactionId}`);
};

export const cancelSchedule = (smsScheduleIds) => {
    return $http.delete(`/user/sms/schedules/cancel`, {
        data: {
            smsScheduleIds,
        },
    });
};

export const getTryDemoBrandnameCondition = () => {
    return $http.get(`/user/sms/trial/condition`);
};

export const getTryDemoBrandnameContent = () => {
    return $http.get(`/user/sms/trial/content`);
};

export const sendTryDemoBrandname = (data) => {
    return $http.post('/user/sms/trial', data);
};
